export default "/assets/svg/pdf.svg"